import axios from 'axios';
const API_URL = process.env.REACT_APP_API;

export async function getAllCuentas() {
  const response = await axios.get(
    `${API_URL}catalogos/account?limit=1000&page=1`
  );
  const data = response.data.doc.data;
  return data;
}

export async function getEducationDegree(filter: any) {
  const params = new URLSearchParams();

  if (filter.order) params.set('order', filter.order);
  if (filter.degreeId)
    params.set('education_degree_id', filter.degreeId.toString());
  if (filter.init_date) params.set('init_date', filter.init_date);
  if (filter.end_date) params.set('end_date', filter.end_date);

  const response = await axios.get(
    `${API_URL}dashboard/students-by-level?${params.toString()}`
  );
  const data = response.data.doc.data;
  return data;
}

export async function getEducationColony(filter: any) {
  const params = new URLSearchParams();

  if (filter.order) params.set('order', filter.order);
  if (filter.cityId) params.set('city_id', filter.cityId.toString());
  if (filter.init_date) params.set('init_date', filter.init_date);
  if (filter.end_date) params.set('end_date', filter.end_date);

  const response = await axios.get(
    `${API_URL}dashboard/students-by-colony?${params.toString()}`
  );
  const data = response.data.doc.data;
  return data;
}

export async function getSelectCity() {
  const response = await axios.get(`${API_URL}catalogos/city/nuevo-leon`);
  return response.data.doc.data.map((item: any) => ({
    ...item,
    label: item.name,
    value: item.id,
  }));
}

export async function getAllMOvInventario(filter: any) {
  const params = new URLSearchParams();
  if (!filter) {
    return false;
  }
  if (filter.init_date) params.set('init_date', filter.init_date);
  if (filter.end_date) params.set('end_date', filter.end_date);
  const response = await axios.get(
    `${API_URL}dashboard/stock-status?${params}`
  );
  const data = response.data.doc.data;
  return data;
}

export async function getStudentAge(filter: any) {
  const params = new URLSearchParams();
  if (!filter) {
    return false;
  }
  if (filter.init_date) params.set('init_date', filter.init_date);
  if (filter.end_date) params.set('end_date', filter.end_date);
  const response = await axios.get(
    `${API_URL}dashboard/students-by-age?${params}`
  );
  const data = response.data.doc.data;
  return data;
}

export async function getSimAsignadas(filter: any) {
  const params = new URLSearchParams();

  if (filter.init_date) params.set('init_date', filter.init_date);
  if (filter.end_date) params.set('end_date', filter.end_date);

  const response = await axios.get(
    `${API_URL}catalogos/zonas/total?${params.toString()}`
  );
  const data = response.data.doc.data.zonas;
  return data;
}

export async function getSimAsignadasById(filter: number, date: any) {
  const params = new URLSearchParams();

  if (filter) params.set('zona_id', filter.toString());
  if (date.init_date) params.set('init_date', date.init_date);
  if (date.end_date) params.set('end_date', date.end_date);

  const response = await axios.get(
    `${API_URL}dashboard/stock-status-zona?${params.toString()}`
  );
  const data = response.data.doc.data.zona;
  return data;
}
